var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-translation-wrapper",
      attrs: { "data-grm-comp": "RoomTranslation" },
    },
    [
      _c("div", { staticClass: "room-translation-container" }, [
        _c(
          "div",
          { staticClass: "room-translation-title" },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("extendMenu.translation.title"))),
            ]),
            _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
          ],
          1
        ),
        _c("div", { staticClass: "room-translation-item-box" }, [
          _c(
            "ul",
            { staticClass: "room-translation-item-list" },
            _vm._l(_vm.translationLangItems, function (item) {
              return _c(
                "li",
                {
                  key: item.key,
                  staticClass: "room-translation-item",
                  on: {
                    click: function ($event) {
                      return _vm.onEnableTranslation(item)
                    },
                  },
                },
                [
                  _c("div", { class: `item-icon bg-${item.key}` }),
                  _c("button", { staticClass: "item-btn" }, [
                    _c("span", { class: item.key }),
                    _c("span", { staticClass: "item-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(`extendMenu.translation.lang.${item.key}`)
                        )
                      ),
                    ]),
                    _c("span", { staticClass: "item-lang" }, [
                      _vm._v(_vm._s(item.lang)),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }